import { useState } from "react";
import { Logo } from "./Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { AuthDialog } from "./AuthDialog";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { LayoutDashboard, LogOut, User as UserIcon, Heart, MapPin } from "lucide-react";
import { toast } from "sonner";

export const Header = () => {
  const { user, logout } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const navigate = useNavigate();

  const dashPath = user && user.role === "admin" ? "/admin" : user && user.role === "partner" ? "/partner" : "/meine-buchungen";

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto pl-2 pr-3 sm:pl-3 sm:pr-6 h-20 flex items-center justify-between">
        <Logo />
        <div className="flex items-center gap-3">
          <Button variant="ghost" className="gap-1.5 hidden sm:flex" onClick={() => navigate("/karte")} data-testid="nav-map"><MapPin className="w-4 h-4" /> Karte</Button>
          {user && user.role ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="gap-2 rounded-full" data-testid="user-menu-trigger">
                  <span className="w-6 h-6 rounded-full bg-emerald-600 text-white text-xs flex items-center justify-center font-bold">
                    {user.name?.[0]?.toUpperCase()}
                  </span>
                  <span className="hidden sm:inline max-w-[120px] truncate">{user.name}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-52">
                <div className="px-2 py-1.5 text-xs text-slate-500">
                  {user.role === "admin" ? "Administrator" : user.role === "partner" ? "Partner" : "Kunde"}
                </div>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate(dashPath)} data-testid="menu-dashboard">
                  <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard
                </DropdownMenuItem>
                {user.role === "customer" && (
                  <DropdownMenuItem onClick={() => navigate("/meine-buchungen")} data-testid="menu-bookings">
                    <UserIcon className="w-4 h-4 mr-2" /> Meine Buchungen
                  </DropdownMenuItem>
                )}
                {user.role === "customer" && (
                  <DropdownMenuItem onClick={() => navigate("/favoriten")} data-testid="menu-favorites">
                    <Heart className="w-4 h-4 mr-2" /> Favoriten
                  </DropdownMenuItem>
                )}
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={async () => { await logout(); toast.success("Abgemeldet"); navigate("/"); }} data-testid="menu-logout">
                  <LogOut className="w-4 h-4 mr-2" /> Abmelden
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <Button variant="ghost" onClick={() => setAuthOpen(true)} data-testid="header-login-btn">Anmelden</Button>
              <Button className="bg-emerald-600 hover:bg-emerald-700 rounded-full" onClick={() => setAuthOpen(true)} data-testid="header-register-btn">
                Loslegen
              </Button>
            </>
          )}
        </div>
      </div>
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
    </header>
  );
};
